import {
  DocumentIcon,
} from "components/Icons/Icons";
import Main from "views/Home/Main";
import AllProductsIndex from "views/Home/AllProducts"
import Contact from "./views/Contact";
import Support from "./views/Support";
import PatentsCertifications from "./views/Certifications";
import {ChevronRightIcon} from "@chakra-ui/icons";
import { products, categories } from "data/products";

export default function getRoutes(t) {
  // Build product sidebar routes from data
  const productCategoryRoutes = categories.map((cat) => {
    const catProducts = products.filter((p) => p.category === cat.key);
    return {
      name: t(`common:categories.${cat.key}`).toUpperCase(),
      path: cat.path,
      collapse: true,
      icon: <DocumentIcon color="inherit" />,
      items: catProducts.map((p) => ({
        name: p.model,
        path: `${cat.path}/${p.id}`,
        layout: "",
      })),
    };
  });

  const dashRoutes = [
    {
      name: t("common:nav.aboutUs").toUpperCase(),
      category: "aboutus",
      items: [
        {
          name: t("common:nav.home").toUpperCase(),
          path: "/home",
          icon: <ChevronRightIcon color="inherit" />,
          component: Main,
          layout: "",
        },
        {
          name: t("common:nav.allProducts").toUpperCase(),
          path: "/allproducts",
          icon: <ChevronRightIcon color="inherit" />,
          component: AllProductsIndex,
          layout: "",
        },
        {
          name: t("common:nav.certifications").toUpperCase(),
          path: "/certifications",
          icon: <ChevronRightIcon color="inherit" />,
          component: PatentsCertifications,
          layout: "",
        },
        {
          name: t("common:nav.contactUs").toUpperCase(),
          path: "/contactus",
          icon: <ChevronRightIcon color="inherit" />,
          component: Contact,
          layout: "",
        },
        {
          name: t("common:nav.support").toUpperCase(),
          path: "/support",
          icon: <ChevronRightIcon color="inherit" />,
          component: Support,
          layout: "",
        },
      ]
    },
    {
      name: t("common:nav.products").toUpperCase(),
      category: "product",
      items: productCategoryRoutes,
    }
  ];

  return dashRoutes;
}
